import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject } from 'rxjs';
import { authCodeFlowConfig } from './auth-config';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

private isAuthenticatedSubject$ = new BehaviorSubject<boolean>(false);
public isAuthenticated$ = this.isAuthenticatedSubject$.asObservable();

private isDoneLoadingSubject$ = new BehaviorSubject<boolean>(false);
public isDoneLoading$ = this.isDoneLoadingSubject$.asObservable();

constructor(private authService: OAuthService, private router: Router, private http: HttpClient) {
  
  this.authService.configure(authCodeFlowConfig);
  this.authService.setupAutomaticSilentRefresh();

  this.authService.events.subscribe(_ => {
    this.isAuthenticatedSubject$.next(this.hasValidToken());
  });
  this.isAuthenticatedSubject$.next(this.hasValidToken());
  
}

 public runOAuthLogin() : Promise<void> {
  return this.authService.loadDiscoveryDocument()
  .then(() => this.authService.tryLoginCodeFlow())
  .then(() => this.isDoneLoadingSubject$.next(true))
  .catch(() => this.isDoneLoadingSubject$.next(true));
}


public login(targetUrl?: string) {
  this.authService.initLoginFlow(targetUrl || this.router.url);
}

public logout() {
  this.http.post(environment.apiGatewayUrl + environment.endPointSufix 
    + "/user/regLogout", null).subscribe(
    (res) => {
      this.authService.revokeTokenAndLogout().then((_) => {
        window.location.href = environment.apiGatewayUrl + '/logout';
      });
      res;
    }
  );
  
}

public get isEditRegra() { 
  //return this.idClaims['sub'].startsWith('Admin') || this.idClaims['sub'].startsWith('Adm Regras')
  return true;
}


public hasValidToken() { return this.authService.hasValidAccessToken() && this.authService.hasValidIdToken(); }
public get accessToken() { return this.authService.getAccessToken(); }
public get refreshToken() { return this.authService.getRefreshToken(); }
public get idToken() { return this.authService.getIdToken(); }
public get idClaims() {return this.authService.getIdentityClaims()}
public get isNaoLicenciado() { return this.idClaims['sub'] === 'naoLicenciado'}
public get role() {return this.idClaims['sub'].includes(' - ') ? this.idClaims['sub'].split(' - ')[0].trim() 
  : this.idClaims['sub'].trim();}
}
